/* Pause control for background-video sections.
   ------------------------------------------------------------------
   WCAG 2.2.2 (Level A) requires a way to stop motion that starts automatically, lasts more
   than five seconds and sits alongside other content. A looping background video is exactly
   that, and a loop does not qualify for the five-second exemption because it never stops.

   The theme loads its video inside <deferred-media><template>, so the <video> element does
   not exist until the section is scrolled near. We therefore resolve it lazily on first click
   and again whenever it is replaced, rather than caching a reference at load. */

(() => {
  const LABEL_PAUSE = 'Pause';
  const LABEL_PLAY = 'Play';

  const findVideo = (button) => {
    const section = button.closest('.image-overlay');
    return section ? section.querySelector('video') : null;
  };

  const setState = (button, paused) => {
    const label = button.querySelector('[data-fa-video-toggle-label]');
    if (label) label.textContent = paused ? LABEL_PLAY : LABEL_PAUSE;
    button.setAttribute('aria-pressed', paused ? 'true' : 'false');
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-fa-video-toggle]');
    if (!button) return;

    const video = findVideo(button);
    if (!video) return;

    if (video.paused) {
      // play() rejects if the browser blocks it (iOS Low Power Mode is the common case).
      // If that happens the poster stays put, which is the correct fallback — so keep the
      // button showing "Play" rather than lying about the state.
      video.play().then(() => setState(button, false)).catch(() => setState(button, true));
    } else {
      video.pause();
      setState(button, true);
    }
  });

  /* Respect a reduced-motion preference without waiting for a click. The CSS hides the video,
     but hiding it does not stop it decoding, so pause it too and flip the button. */
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const applyReduced = () => {
    if (!reduce.matches) return;
    document.querySelectorAll('[data-fa-video-toggle]').forEach((button) => {
      const video = findVideo(button);
      if (video && !video.paused) video.pause();
      setState(button, true);
    });
  };
  reduce.addEventListener('change', applyReduced);
  document.addEventListener('DOMContentLoaded', applyReduced);
  // The video arrives late via <deferred-media>, so re-apply once it exists.
  document.addEventListener('play', applyReduced, true);
})();
